import type { FC } from 'react';
import { SkipRenderOnServer } from '../../utils/SkipRenderOnServer';
import { ClientOnlyModal, IModalProps } from './internal/ClientOnlyModal';

export type { IModalProps };

/**
 * Modal component used to display content in a modal dialog window over the current page.
 *
 * This component is designed to be used in a client-side environment and will not render on the server.
 *
 * Use it in these main situations:
 * - When wanting to display a modal over a curtain over screen
 * - When wanting to display a fullscreen modal over the current page
 * - When wanting to display a left/right side panel modal.
 *
 * @example
 *
 * ```tsx
 * <Modal isOpen={opened} onClose={closeHandler}>
 *   <ModalHeader>
 *     <h2>Modal Title</h2>
 *   </ModalHeader>
 *   <Card>
 *     <p>Modal content</p>
 *   </Card>
 * </Modal>
 * ```
 */
export const Modal: FC<IModalProps> = (props) => {
  return (
    <SkipRenderOnServer>
      <ClientOnlyModal {...props} />
    </SkipRenderOnServer>
  );
};
